var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrecredi_qrcode"},[_c('div',{staticClass:"arrecredi_qrcode_title"},[_vm._v("Descargar App")]),_c('div',{staticClass:"arrecredi_qrcode_dv"},[_c('img',{attrs:{"src":require("./assets/img/arrecredi_qrcode_1.jpeg"),"alt":""}})])])
}]

export { render, staticRenderFns }